<div class="sectionbar">
  <app-aftale-nav></app-aftale-nav>
  <div class="sectionbar__actions">
    <button class="btn-icon green" matTooltip="Opret serviceaftale" [routerLink]="'create'" [disabled]="!canWrite">
      <mat-icon svgIcon="add"></mat-icon>
      <span>Opret serviceaftale</span>
    </button>
  </div>
</div>
<div class="topbar">
  <div>
    <h1>Serviceaftaler</h1>
  </div>
  <div class="topbar__actions">
    @if (serviceaftaler.length > 0) {
      <small>
        Viser {{ serviceaftaler.length }}
        @if (isAdmin) {
          <span>af {{ rowCount }}</span>
        }
        @if (!isAdmin && rowCount > 1000) {
          <span>af 1000+</span>
        }
        @if (!isAdmin && rowCount <= 1000) {
          <span>af {{ rowCount }}</span>
        }
        aftaler
      </small>
    }
    <button class="btn-icon" [matTooltip]="'Download aftale listen som excel ark'">
      <mat-icon svgIcon="download" class="icon-32" (click)="download()"></mat-icon>
    </button>
    <app-aftale-filter [filter]="filter" class="filter flex"></app-aftale-filter>
    <div class="search-wrap">
      <app-search [searchString]="searchQuery" label="Find serviceaftale"></app-search>
    </div>
  </div>
</div>
<div class="page__content subscriptions subscriptions--list">
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    (matSortChange)="sortData($event)"
    [matSortActive]="filter.orderBy"
    [matSortDirection]="filter.orderDir"
    class="mat-elevation-z0 has-notifications table-show-overflow"
    >
    <ng-container matColumnDef="actions">
      <th mat-header-cell class="hidden-cell" *matHeaderCellDef></th>
      <td mat-cell class="hidden-cell" [class.hidden-cell--pinned]="button(serviceaftale) > 0" *matCellDef="let serviceaftale">
        <button
          type="button"
          class="btn-icon opacity-hover"
          [class.opfoelgning-bookmark]="button(serviceaftale)"
          (click)="opfoelgning($event, serviceaftale)"
          [disabled]="!canWrite"
          >
          <app-opfoelgning-button [opfoelgningList]="serviceaftale.opfoelgningList"></app-opfoelgning-button>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="Serviceabonnement.Produkt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <mat-icon [svgIcon]="getProductIcon(serviceaftale)" [matTooltip]="getProductIcon(serviceaftale) | titlecase"></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="ServiceaftaleState">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <mat-icon [matTooltip]="serviceaftale.serviceaftaleState.text" [svgIcon]="getStatusIcon(serviceaftale)"></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="kundenr">
      <th mat-header-cell *matHeaderCellDef>Kundenr</th>
      <td mat-cell *matCellDef="let serviceaftale">
        @if (serviceaftale.kunde) {
          <div>{{ serviceaftale.kunde ? serviceaftale.kunde.okKundeNr : '' }}</div>
        }
        @if (!serviceaftale.kunde) {
          <div>
            <span matTooltip="Ingen data i G4">N/A</span>
          </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="kundeNavn">
      <th mat-header-cell *matHeaderCellDef>Navn</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.kunde ? serviceaftale.kunde.anlaegsadresse?.name : 'N/A' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="OkKundeAftaleNr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Aftalenr</th>
      <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.okKundeAftaleNr }}</td>
    </ng-container>
    <ng-container matColumnDef="adresse">
      <th mat-header-cell *matHeaderCellDef>Anlægsadresse</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <div class="truncate" [matTooltip]="concatAdresseLokation(serviceaftale)">
          {{ concatAdresseLokation(serviceaftale) }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="telefon">
      <th mat-header-cell *matHeaderCellDef>Telefonnr.</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.kunde?.anlaegsadresse?.phone ? ($safeNavigationMigration(serviceaftale.kunde.anlaegsadresse?.phone) | dkPhoneNumber) : '' }}
        {{ serviceaftale.kunde?.anlaegsadresse?.phone && serviceaftale.kunde?.anlaegsadresse?.mobile ? '/' : '' }}
        {{ serviceaftale.kunde?.anlaegsadresse?.mobile ? ($safeNavigationMigration(serviceaftale.kunde.anlaegsadresse?.mobile) | dkPhoneNumber) : '' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Ajourtid">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Senest ændret</th>
      <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.modifiedOn | date : 'shortDate' }}</td>
    </ng-container>
    <ng-container matColumnDef="Oprettid">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Oprettet</th>
      <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.createdOn | date : 'shortDate' }}</td>
    </ng-container>
    <ng-container matColumnDef="Partner.Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.partner?.name }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [appScrollToRow]="prevRow"
      [rowId]="row.okKundeAftaleNr"
      (rowActive)="highLight($event)"
      (click)="onRowClick(row)"
      (dblclick)="onRowDblClick(row)"
      [class.active]="globalActiveRowID == row.id"
    ></tr>
  </table>
  @if (page < pageCount) {
    <div class="align-center margin-top-x2">
      <button type="button" mat-raised-button color="accent" class="btn-trans mat-elevation-z0" (click)="more()">Vis flere aftaler</button>
    </div>
  }
</div>
@if (quickViewOpen) {
  <div class="quick-view" [@inOutAnimation]>
    <button type="button" class="btn-icon btn-close" (click)="closeQuickView()" title="Luk">
      <mat-icon>close</mat-icon>
    </button>
    <app-quickview [serviceaftale]="selectedaftale"></app-quickview>
    <div class="quick-view__bottom">
      <app-opfoelgning-action
        [opfoelgningList]="selectedaftale.opfoelgningList"
        (opfoelgningChange)="onOpfoelgningChanged($event)"
        [entityNo]="selectedaftale.serviceAftaleNo"
        [serviceaftale]="selectedaftale"
      ></app-opfoelgning-action>
      <button mat-raised-button color="primary" (click)="onRowDblClick(selectedaftale)">Åben aftalen</button>
    </div>
  </div>
}
